import src from "IMAGE";
export default { src, width: 2668, height: 303, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJWnrq+Soqeovb29u5+fn52np6ell5eXlYmJiYipqamnVLUUQm6aGxsAAAAASUVORK5CYII="};
